import React, { ReactElement } from 'react';

import { Expression } from '@philips-emr/tws-constants';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames } from '@philips-emr/tws-utils';

export interface NotFoundProps {
  className?: string;
  showImage?: boolean;
  subtitleExpression?: string;
  titleExpression?: string;
}

function NotFound(props: NotFoundProps): ReactElement {
  const {
    className,
    showImage = true,
    subtitleExpression = '',
    titleExpression = Expression.RESULTS_NOT_FOUND,
  } = props;

  const names = classNames({
    'o-not-found': true,
    [`${className}`]: Boolean(className),
  });

  return (
    <div className={names}>
      {showImage && <div className="o-not-found__img u-hide@xsm" />}
      <span className="o-not-found__title">{msg(titleExpression)}</span>
      <span className="o-not-found__subtitle">{msg(subtitleExpression)}</span>
    </div>
  );
}

export default NotFound;
